import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import FullCalendarReact from "../../components-react/FullCalendarReact";
import {
  fetchURECalendarData,
  fetchUREDetailsData,
} from "../../../redux/reducers/apiSlice";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import UREdetails from "../details/UREdetails";
import Loader from "../../ui/Loader";
import { convertThenFormat } from "../../common-data/Converts";
import GlobalCardFilters from "../../../pages/home/common/GlobalCardFilters";

const CalendarView = ({
  userInfoData,
  prevFilters,
  prevAllFilters,
  prevSetAllFilters,
}) => {
  const dispatch = useDispatch();

  const { loading, ureCalendarViewData, ureDetails } = useSelector(
    (state) => state.api
  );

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";
  const isManagerRole = ["fitness_manager", "sales_manager", "club_manager"].includes(userInfoData?.account_type);

  const [isPage, setIsPage] = useState(0);
  const iniCalViewData = {
    allUREViewData: [],
    calDetailData: [],
    calDetailsPagination: [],
    calStatsCard: {},
  };
  const [calViewData, setCalViewData] = useState(iniCalViewData);
  const iniModvalues = {
    isModOpen: false,
    selDate: "",
    selType: "",
  };
  const [modValues, setValues] = useState(iniModvalues);
  const iniCalDetailFilters = {
    selectedGym: prevAllFilters.selectedGym
      ? prevAllFilters.selectedGym
      : !isAdmin && !isClusterManager && !isManagerRole
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.uid ||
            userInfoData?.user_id ||
            "",
        }
      : "",
    selectedOtherUsers: prevAllFilters.selectedOtherUsers
      ? prevAllFilters.selectedOtherUsers
      : "",
      // !isAdmin
      // ? {
      //     label: userInfoData?.name || "",
      //     value: userInfoData?.uid || userInfoData?.user_id || "",
      //   }
      // : "",
    selRecurringStatus: "",
    selButtonEnabled: "",
    selAddNotAddToLead: "",
    searchString: "",
  };
  const [calDetailFilters, setCalDetailFilters] = useState(iniCalDetailFilters);
  const iniFilters = {
    limit: 10,
    page: isPage + 1 || 1,
    gym_id: calDetailFilters.selectedGym?.value || "",
    sub_added_by: calDetailFilters.selectedOtherUsers?.value || "",
    start_date: modValues.selDate || "",
    end_date: modValues.selDate || "",
    type: modValues.selType || "",
    is_recurring: calDetailFilters.selRecurringStatus?.value || "",
    is_btn_enabled: calDetailFilters.selButtonEnabled?.value || "",
    added_to_lead: calDetailFilters.selAddNotAddToLead?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);

  function closeModal() {
    setValues(iniModvalues);
    setCalDetailFilters(iniCalDetailFilters);
    setFilters(iniFilters);
    setSelectedTab(0);
  }

  const onClickReset = () => {
    setCalDetailFilters(iniCalDetailFilters);
    setFilters(iniFilters);
  };

  function getCalendarViewData(filters) {
    dispatch(
      fetchURECalendarData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getCalendarDetails(filters) {
    dispatch(
      fetchUREDetailsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const onClickSearch = () => {
    if (calDetailFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({
        ...prevs,
        search: calDetailFilters.searchString,
      }));
    }
  };

  useEffect(() => {
    if (prevFilters.start_date && prevFilters.end_date) {
      getCalendarViewData(prevFilters);
    }
  }, [
    prevFilters.start_date,
    prevFilters.end_date,
    prevFilters.gym_id,
    prevFilters.sub_added_by,
  ]);

  useEffect(() => {
    if (ureCalendarViewData?.status && ureCalendarViewData?.data?.length > 0) {
      setCalViewData((prevs) => ({
        ...prevs,
        allUREViewData: ureCalendarViewData.data.map((event) => ({
          title: "",
          date: event.date,
          extendedProps: {
            total_expiry: event.total_expiry,
            total_expiry_amount: event.total_expiry_amount,

            total_renewals: event.total_renewals,
            total_renewals_amount: event.total_renewals_amount,
            renewal_percentage: event.renewal_percentage,

            total_unpaid: event.total_unpaid,
            total_unpaid_amount: event.total_unpaid_amount,

            total_past_renewals: event.total_past_renewals,
            total_past_renewals_amount: event.total_past_renewals_amount,

            date: event.date,
          },
        })),
      }));
    } else {
      setCalViewData(iniCalViewData);
    }
  }, [ureCalendarViewData]);

  // useEffect(() => {
  //   setCalDetailFilters((prevs) => ({
  //     ...prevs,
  //     selectedGym: prevAllFilters.selectedGym
  //       ? prevAllFilters.selectedGym
  //       : !isAdmin
  //       ? {
  //           label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
  //           value:
  //             userInfoData?.gym_id ||
  //             userInfoData?.uid ||
  //             userInfoData?.user_id ||
  //             "",
  //         }
  //       : "",
  //     selectedOtherUsers: prevAllFilters.selectedOtherUsers
  //       ? prevAllFilters.selectedOtherUsers
  //       : "",
  //       // !isAdmin
  //       // ? {
  //       //     label: userInfoData?.name || "",
  //       //     value: userInfoData?.uid || userInfoData?.user_id || "",
  //       //   }
  //       // : "",
  //   }));
  // }, [userInfoData?.gym_id, prevAllFilters.selectedGym, prevAllFilters.selectedOtherUsers]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1 || 1,
    }));
  }, [isPage]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      gym_id: calDetailFilters.selectedGym?.value || "",
      sub_added_by: calDetailFilters.selectedOtherUsers?.value || "",
      start_date: modValues.selDate || "",
      end_date: modValues.selDate || "",
      type: modValues.selType || "",
      is_recurring: calDetailFilters.selRecurringStatus?.value || "",
      is_btn_enabled: calDetailFilters.selButtonEnabled?.value || "",
      added_to_lead: calDetailFilters.selAddNotAddToLead?.value || "",
    }));
    setIsPage(0);
  }, [
    calDetailFilters.selectedGym,
    calDetailFilters.selectedOtherUsers,
    modValues.selDate,
    modValues.selType,
    calDetailFilters.selRecurringStatus,
    calDetailFilters.selButtonEnabled,
    calDetailFilters.selAddNotAddToLead
  ]);

  useEffect(() => {
    if (filters.start_date && filters.type) {
      if (selectedTab === 1) {
        filters.view_type = "same_day_renewal";
      } else if (selectedTab === 2) {
        filters.view_type = "other_day_renewal";
      } else {
        filters.view_type = "";
      }

      getCalendarDetails(filters);
    }
  }, [filters, selectedTab]);

  useEffect(() => {
    if (ureDetails?.status && ureDetails?.data?.length > 0) {
      setCalViewData((prevs) => ({
        ...prevs,
        calDetailData: ureDetails.data,
        calDetailsPagination:
          ureDetails?.pagination?.length > 0 ? ureDetails.pagination : [],
        calStatsCard: ureDetails.stats || {},
      }));
    } else {
      setCalViewData((prevs) => ({
        ...prevs,
        calDetailData: [],
        calDetailsPagination: [],
        calStatsCard: {},
      }));
    }
  }, [ureDetails]);

  useEffect(() => {
    if (calDetailFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
    }
  }, [calDetailFilters.searchString]);

  const renderEventContent = useCallback(
    (eventInfo) => {
      const {
        total_expiry,
        total_expiry_amount,

        total_renewals,
        total_renewals_amount,
        renewal_percentage,

        total_unpaid,
        total_unpaid_amount,

        total_past_renewals,
        total_past_renewals_amount,

        date,
      } = eventInfo.event.extendedProps;

      const onClickCard = (e, date, type) => {
        e.stopPropagation();

        setValues((prevs) => ({
          ...prevs,
          isModOpen: true,
          selDate: date,
          selType: type,
        }));
      };

      return (
        <div className="cal-view-grid-container">
          {loading ? (
            <Loader />
          ) : (
            <>
              <button
                type="button"
                className="cal-view-btn expiry"
                style={{
                  cursor: parseInt(total_expiry || 0)
                    ? "pointer"
                    : "not-allowed",
                }}
                onClick={(e) =>
                  parseInt(total_expiry || 0) &&
                  onClickCard(e, date, "total_expiry")
                }
              >
                Expiry:{" "}
                <span className="btn-value">
                  {total_expiry} <br /> @ ₹
                  {convertThenFormat(total_expiry_amount || 0)}
                </span>
              </button>
              <button
                type="button"
                className="cal-view-btn renewals"
                style={{
                  cursor: parseInt(total_renewals_amount || 0)
                    ? "pointer"
                    : "not-allowed",
                }}
                onClick={(e) =>
                  parseInt(total_renewals_amount || 0) &&
                  onClickCard(e, date, "total_renewals")
                }
              >
                Renewals:{" "}
                <span className="btn-value">
                  {total_renewals} <br />@ ₹
                  {convertThenFormat(total_renewals_amount || 0)} (
                  {convertThenFormat(renewal_percentage || 0)}%)
                </span>
              </button>
              <button
                type="button"
                className="cal-view-btn unpaid"
                style={{
                  cursor: parseInt(total_unpaid_amount || 0)
                    ? "pointer"
                    : "not-allowed",
                }}
                onClick={(e) =>
                  parseInt(total_unpaid_amount || 0) &&
                  onClickCard(e, date, "total_unpaid")
                }
              >
                Unpaid:{" "}
                <span className="btn-value">
                  {total_unpaid} <br />@ ₹
                  {convertThenFormat(total_unpaid_amount || 0)}
                </span>
              </button>
              <button
                type="button"
                className="cal-view-btn past-renewals"
                style={{
                  cursor: parseInt(total_past_renewals_amount || 0)
                    ? "pointer"
                    : "not-allowed",
                }}
                onClick={(e) =>
                  parseInt(total_past_renewals_amount || 0) &&
                  onClickCard(e, date, "total_past_renewals")
                }
              >
                Past Renewals:{" "}
                <span className="btn-value">
                  {total_past_renewals} <br />@ ₹
                  {convertThenFormat(total_past_renewals_amount || 0)}
                </span>
              </button>
            </>
          )}
        </div>
      );
    },
    [setValues]
  );

  // console.log("calViewData.allUREViewData=> ", calViewData.allUREViewData);

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={closeModal}
        contentLabel="Details Modal"
        ariaHideApp={false}
      >
        <div className={`createNewCTOModalContainer`}>
          <ModalHeadAndClose
            title={modValues.selType?.replace(/_/g, " ")}
            onClose={closeModal}
          />

          <GlobalCardFilters
            user={userInfoData}
            allFilters={calDetailFilters}
            setAllFilters={setCalDetailFilters}
            onClickReset={onClickReset}
            isSearchbar={true}
            onClickSearch={onClickSearch}
            searchFilterApplied={searchFilterApplied}
            isURE={true}
          />

          <UREdetails
            tbData={calViewData.calDetailData}
            tbPagination={calViewData.calDetailsPagination}
            isPage={isPage}
            setIsPage={setIsPage}
            setSelectedTab={setSelectedTab}
            clickedCard={modValues.selType}
            calStatsCard={calViewData.calStatsCard}
            is_recurring={filters.is_recurring}
            userInfoData={userInfoData}
            callFunction={() => {
              if (filters.start_date && filters.type) {
                if (selectedTab === 1) {
                  filters.view_type = "same_day_renewal";
                } else if (selectedTab === 2) {
                  filters.view_type = "other_day_renewal";
                } else {
                  filters.view_type = "";
                }

                getCalendarDetails(filters);
              }
            }}
          />
        </div>
      </Modal>

      <div className="big-calendar-container">
        <FullCalendarReact
          events={calViewData.allUREViewData}
          setCurrentMonth={prevSetAllFilters}
          renderEventContent={renderEventContent}
        />
      </div>
    </>
  );
};

export default CalendarView;
